import SectionContainer from '@common/components/SectionContainer';
import { token } from 'odyssey';
import styled from 'styled-components';

export const FeaturedTitle = styled.h2`
  font-size: ${token('font-size-2xl')};
  color: ${token('color-section-title')};
  margin: 0;
`;

export const FeaturedProductsWrapper = styled(SectionContainer)`
  margin-top: 50px;
  margin-bottom: 80px;
`;

export const FeaturedCategoriesWrapper = styled(SectionContainer)`
  margin-bottom: 100px;
  padding: 0;
`;
